<div class="word">{{ word1 }}</div>
<div class="word">{{ word2 }}</div>
<button id="refresh" (click)="refresh()">Refresh</button>
